/* cwc-trusted-certificate */

.cwc-trusted-certificate-render {
  display: inline-flex;

  [id*='minimized-trustbadge-'] {
    width: 143px !important;
    transform: scale(0.9) !important;
    transform-origin: left top !important;
    border-width: 0 !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4) !important;

    // adjust text under separation line
    p:last-of-type {
      position: relative !important;
      margin-top: 4px !important;
      margin-bottom: 1.5px !important;
      line-height: 9px !important;
    }
  }

  // adjust icon
  img {
    margin-left: 3px !important;
    box-shadow: none !important;
  }
}

@media only screen and (max-width: 639px) {
  [id*='trustbadge-container-custom-maximized-'] {
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    background: rgba(0, 0, 0, 0.4) !important;

    > div {
      > [id*='maximized-trustbadge-'] {
        top: 25% !important;
        right: 0 !important;
        left: 0 !important;
        width: 280px !important;
        height: 380px !important;
        margin-right: auto !important;
        margin-left: auto !important;
      }
    }
  }
}

[id*='trustbadge-container-custom-maximized-'] {
  [id*='trustcard-'] {
    right: auto !important;
    left: 20px !important;
  }
}
